import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import SharesListHeader from './ListHeader';
import SharesListItem from './ListItem';
import EmptyShareLinks from '../../containers/EmptyContainers/ShareLinks';

import NothingFound from '../NothingFound';

const SharesList = ({
  shares,
  scope,
  search,
  afterEditShare,
  loadShares,
  ...props
}) => (
  <>
    {shares.length > 0 ? (
      <div className="table-wrapper">
        <Table className="users-list shares-list files-list" responsive>
          <thead>
            <SharesListHeader
              scope={scope}
              {...props}
            />
          </thead>
          <tbody>
            {shares.map(share => (
              <SharesListItem
                key={share.uuid}
                share={share}
                scope={scope}
                afterEditShare={afterEditShare}
                loadShares={loadShares}
              />
            ))}
          </tbody>
        </Table>
      </div>
    ) : (
      <>
        {search ? (
          <NothingFound />
        ) : (
          <EmptyShareLinks />
        )}
      </>
    )}
  </>
);

SharesList.propTypes = {
  shares: PropTypes.array.isRequired,
  scope: PropTypes.string.isRequired,
  search: PropTypes.string,
  afterEditShare: PropTypes.func.isRequired,
  loadShares: PropTypes.func.isRequired,
};

SharesList.defaultProps = {
  search: '',
};

export default SharesList;
